export const defaultImages = {
  banner: `${process.env.NEXT_PUBLIC_CDN_V2}/menu/banner/default.png`,
  user: `${process.env.NEXT_PUBLIC_CDN_V2}/user/default.svg`,
  fortuneTeller: `${process.env.NEXT_PUBLIC_CDN_V2}/fortune_teller/default.png`,
};
